import React from 'react'

const IconEmail = ({ style = {}, ...props }) => {
  return (
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      style={style}
      {...props}>
      <g id="icon-email">
        <path
          d="M14.7316519,0.110543784 L0.450049837,8.08740303 C0.155888193,8.24778431 -0.0193330167,8.56827975 0.00170319849,8.90746957 C0.0227394137,9.24665939 0.236163129,9.54214458 0.54780036,9.66354123 L4.45447938,11.140107 L4.69175415,14.5170597 C4.73970723,15.1694234 5.17212353,15.726601 5.78419346,15.924691 C6.39626339,16.122781 7.06508765,15.9220084 7.47388442,15.4174669 L9.40299517,13.0124094 L13.5970774,14.5996112 C13.8447677,14.6920205 14.1205068,14.6623805 14.3438059,14.5193431 C14.567105,14.3763057 14.7127902,14.1359965 14.7383357,13.8685622 L15.9957249,0.954781954 C16.0274593,0.632795147 15.8807334,0.319557714 15.6150611,0.142122835 C15.3493889,-0.0353120441 15.008881,-0.0474841108 14.7316519,0.110543784 Z M13.152605,4.50194395 L8.42047709,11.4098887 C8.02365056,11.936804 7.28989468,12.0520376 6.75569872,11.671336 C6.22150277,11.2906344 6.07627495,10.5489817 6.42619933,9.98864101 C6.5289627,9.84481414 12.2912307,4.01429428 12.4040198,3.88748834 C12.5805363,3.69104389 12.8772984,3.6701829 13.0786323,3.84006624 C13.2799662,4.00994958 13.3150794,4.31084345 13.1584533,4.52407116 L13.1534404,4.50279499 L13.152605,4.50194395 Z"
          id="Shape"
        />
      </g>
    </svg>
  )
}

export default IconEmail
